import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Cookies from 'js-cookie';

const OAuthCallback: React.FC = () => {
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const oauthStatus = searchParams.get('oauth');
    const error = searchParams.get('error');

    if (oauthStatus === 'success') {
      setStatus('success');
      setMessage('第三方登录成功！正在跳转...');

      // 检查是否有访问令牌
      const accessToken = Cookies.get('accessToken');
      if (accessToken) {
        // 获取重定向路径
        const redirectPath = sessionStorage.getItem('redirectPath') || '/';
        sessionStorage.removeItem('redirectPath');

        setTimeout(() => {
          navigate(redirectPath);
        }, 2000);
      } else {
        setStatus('error');
        setMessage('登录失败：未找到访问令牌');
      }
    } else if (oauthStatus === 'error' || error) {
      setStatus('error');
      setMessage(error ? `登录失败：${error}` : '第三方登录失败，请重试');

      setTimeout(() => {
        navigate('/login');
      }, 3000);
    } else {
      // 处理账户存在的情况
      const accountExists = searchParams.get('account_exists');
      if (accountExists) {
        setStatus('error');
        setMessage('该邮箱已注册，请使用邮箱密码登录，或在设置中关联第三方账户');

        setTimeout(() => {
          navigate('/login');
        }, 5000);
      }
    }
  }, [searchParams, navigate]);

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        flexDirection: 'column',
        textAlign: 'center',
        padding: '20px',
      }}
    >
      {status === 'loading' && (
        <>
          <div>正在处理第三方登录...</div>
          <div style={{ marginTop: '20px' }}>⏳</div>
        </>
      )}

      {status === 'success' && (
        <>
          <div style={{ color: 'green', fontSize: '18px' }}>{message}</div>
          <div style={{ marginTop: '20px' }}>✅</div>
        </>
      )}

      {status === 'error' && (
        <>
          <div style={{ color: 'red', fontSize: '18px' }}>{message}</div>
          <div style={{ marginTop: '20px' }}>❌</div>
          <div style={{ marginTop: '10px', fontSize: '14px', color: '#666' }}>
            页面将在几秒后自动跳转...
          </div>
        </>
      )}
    </div>
  );
};

export default OAuthCallback;
